import React from 'react';
var initialState = {
  data: [],
  isLoading: true
};
var MarketsContext = /*#__PURE__*/React.createContext(initialState);
export default MarketsContext;